<template>
  <div class="odd:bg-gray-100 border border-gray-200 rounded px-4 flex-1">
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="w-48 px-4 text-sm">
            {{ issueDate }}
          </div>
          <div class="flex-1 px-4 text-sm">
            {{ offer.issuerName }}
          </div>
          <div class="flex-1 px-4 text-sm">
            {{ offer.recipientName }}
          </div>
          <div class="w-32 px-4 flex text-right justify-end">
            <BaseBadge v-if="hasOrder" green> Ordered </BaseBadge>
          </div>
          <div class="w-32 px-4 text-sm">
            {{ offer.number }}
          </div>
          <div class="w-32 px-4 text-sm text-right">
            {{ amount }}
          </div>
        </div>
      </div>

      <div class="flex-none pr-4">
        <OfferEditModalForm :offer-id="offer.uuid">
          <template #default="{ setShow }">
            <button
              :disabled="!offer.can.view || disabled"
              class="w-10 h-10 px-4 py-2 rounded text-blue-600 hover:bg-blue-600 hover:text-white focus:outline-none disabled:text-gray-600 disabled:bg-transparent"
              @click="setShow(true)"
            >
              <FontAwesomeIcon icon="chevron-right" />
            </button>
          </template>
        </OfferEditModalForm>
      </div>
    </div>
  </div>
</template>

<script>
import numbro from 'numbro';
import moment from 'moment';
import OfferEditModalForm from 'Forms/OfferModalForm/Edit.vue';

export default {
  components: {
    OfferEditModalForm,
  },
  props: {
    offer: { type: Object, required: true },
    disabled: Boolean,
  },

  computed: {
    amount() {
      return numbro(this.offer.amount || 0).formatCurrency({ mantissa: 2 });
    },
    issueDate() {
      return moment(this.offer.issueDate).format('DD/MM/YYYY');
    },
    hasOrder() {
      return typeof this.offer.order === 'string';
    },
  },
};
</script>
